export const orderLevelTrackingNo = (order) =>
  order?.consignNote || order?.consign_no || null;

export const orderTrackingNos = (order) => {
  if (!order) return [];

  const pieceNos = (order.pieces || [])
    .map((piece) => piece?.consign_no)
    .filter(Boolean);
  if (pieceNos.length > 0) return pieceNos;

  const orderNo = orderLevelTrackingNo(order);
  return orderNo ? [orderNo] : [];
};

export const formatTrackingNos = (order) => orderTrackingNos(order).join(", ");
